<template>
  <SelectTableDialog
    class="pub_dialog"
    :title="$t('transportDeliveryOrder.msg.copyInventory')"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :isMultiple="false"
    :confirmUnchecked="false"
    :defaultVisible="defaultVisible"
    :extraData="extraData"
    :API="productAPI"
    width="1200px"
    @close="close"
    @confirm="confirm"
  ></SelectTableDialog>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/wareHouse/inventoryTransfer.js';
  import DataBaseAPI from '@/api/dataBase';
  import SelectTableDialog from '@/components/SelectTableDialog';

  export default {
    components: {
      SelectTableDialog,
    },
    name: 'copyInventoryTransferList',
    data() {
      return {
        defaultVisible: false,
        productAPI: API.GET_LIST_API,
        companyList: [],
        extraData: {
          allotStatus: '3',
          isShowAll: '0',
          outIsDirectDeliver: '0',
        },
        allotStatusList: [
          { value: 1, label: '已保存' },
          { value: 2, label: '审批中' },
          { value: 3, label: '调拨中' },
          { value: 4, label: '已撤销' },
          { value: 5, label: '调拨完成' },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'allotNo',
            name: this.$t('inventoryTransfer.search.allotNo'),
            type: 'input',
            placeholder: this.$t('inventoryTransfer.search.allotNoPlaceholder'),
          },
          {
            type: 'searchTableSpec',
            prop: 'allotOutStorageNo',
            getSearchCode: 'storageCode',
            isMultiple: true,
            name: this.$t('inventoryTransfer.search.allotOutStorage'),
            searchType: 'warehouse',
          },
          {
            type: 'searchTableSpec',
            prop: 'allotInStorageNo',
            getSearchCode: 'storageCode',
            isMultiple: true,
            name: this.$t('inventoryTransfer.search.allotInStorage'),
            searchType: 'warehouse',
          },
          {
            prop: 'allotDateBegin',
            name: this.$t('inventoryTransfer.search.allotDateStart'),
            type: 'startDaterangePicker',
            placeholder: this.$t('inventoryTransfer.search.allotDateStartPlaceholder'),
          },
          {
            prop: 'allotDateEnd',
            name: this.$t('inventoryTransfer.search.allotDateEnd'),
            type: 'endDaterangePicker',
            placeholder: this.$t('inventoryTransfer.search.allotDateEndPlaceholder'),
          },
          {
            type: 'searchTableSpec',
            prop: 'product',
            isMultiple: true,
            getSearchCode: 'productDetailCode',
            name: this.$t('purchaseReturn.search.productName'),
            searchType: 'goodsDetail',
          },
          {
            prop: 'allotDepartmentNo',
            name: this.$t('inventoryTransfer.search.allotDepartmentName'),
            placeholder: this.$t('inventoryTransfer.search.allotDepartmentNamePlaceholder'),
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            clearable: false,
          },
        ];
      },
      //表格显示字段
      columnList() {
        return [
          {
            prop: 'allotNo',
            label: this.$t('inventoryTransfer.search.allotNo'),
            width: 120,
          },
          {
            prop: 'allotStatusName',
            label: this.$t('inventoryTransfer.search.allotStatus'),
            width: 120,
          },
          { prop: 'allotDate', label: this.$t('inventoryTransfer.search.allotDate'), width: 120 },
          {
            prop: 'allotOutStorage',
            label: this.$t('inventoryTransfer.search.allotOutStorage'),
            width: 120,
          },
          {
            prop: 'allotInStorage',
            label: this.$t('inventoryTransfer.search.allotInStorage'),
            width: 120,
          },
          // { prop: "salesmanName", label: this.$t("inventoryTransfer.search.salesmanNo"), width: 120 },
          {
            prop: 'remainingOutQuantity',
            label: this.$t('transportDeliveryOrder.copySearchTable.remainingQuantityOut'),
          },
          {
            prop: 'allotCreatePersonName',
            label: this.$t('inventoryTransfer.search.allotCreatePerson'),
            width: 120,
          },
          {
            prop: 'allotDepartmentName',
            label: this.$t('inventoryTransfer.search.allotDepartmentName'),
            width: 120,
          },
          {
            prop: 'allotCompanyName',
            label: this.$t('inventoryTransfer.search.allotCompanyName'),
            width: 120,
          },
          {
            prop: 'productName',
            label: this.$t('inventoryTransfer.search.productName'),
            width: 120,
          },
          {
            prop: 'nameVoyageLicense',
            label: this.$t('inventoryTransfer.search.nameVoyageLicense'),
            width: 120,
          },
          {
            prop: 'allotCreateDate',
            label: this.$t('inventoryTransfer.search.allotCreateDate'),
            width: 120,
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getCompany();
    },
    methods: {
      //获取公司信息
      getCompany() {
        this.$axios
          .get(DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.companyList = res.data.data;
            }
          });
      },
      //打开新增页面
      confirm(selections) {
        if (selections.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else if (selections.length > 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.onlyOneSelect'),
            type: 'error',
          });
        } else {
          let path = {
            path: '/logistics/transportDeliveryOrderAdd',
            name: 'transportDeliveryOrderAdd',
            meta: {
              keepAlive: true,
              title: '物流出库单新增',
            },
            query: { flag: 1, no: selections[0].allotNo, type: 0 }, //type 0:新增
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
              this.defaultVisible = false;
            });
          });
        }
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      /**页面必要代码End */
    },
  };
</script>
